module.exports = __webpack_public_path__ + "img/Frame_41.754a27d8.png";